import React, { createRef } from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../Shared/Icon/Icon'

const RecentContactsEmpty = ({ onSearchQueryChange }) => {
  const onSearchSubmit = e => {
    e.preventDefault()

    onSearchQueryChange(ref.current.value)
  }

  const ref = createRef()

  return (
    <div>
      <div className="search-form section__item--contacts-search">
        <form onSubmit={onSearchSubmit}>
          <Icon type="search" />
          <input
            autoComplete="off"
            className="contacts-search__field"
            placeholder="search"
            type="search"
            ref={ref}
          />
        </form>
      </div>
      <div className="no-recent-contacts-message">
        No recent contacts
      </div>
    </div>
  )
}

RecentContactsEmpty.propTypes = {
  onSearchQueryChange: PropTypes.func.isRequired,
}

export default RecentContactsEmpty
